import { CUSTOMER_LEVEL } from '@wyz/types';
import { useManageUsers } from '~/common/api';
import { useApplicationContext } from '~/common/context';

type UseContainerEligibleCustomersArgs = {
  minLevel?: number;
  parentIds?: string[];
  enabled?: boolean;
};

export const useContainerEligibleCustomers = ({
  minLevel = CUSTOMER_LEVEL.N1,
  parentIds = [],
  enabled = true,
}: UseContainerEligibleCustomersArgs = {}) => {
  const { auth } = useApplicationContext();
  const customerQuery = useManageUsers({
    getContainerEligibleCustomersByUser: {
      args: { id: auth.userId as string, minLevel, parentIds },
      enabled: enabled,
      refetchOnMount: true,
    },
  }).getContainerEligibleCustomersByUser;

  return customerQuery;
};
